<template>
    <div>

        <div class="min-h-screen bg-gray-100 flex flex-col">
            <jet-banner class="z-30" />
            <!-- Page Content -->
            <main class="z-20 flex flex-grow w-full justify-center ">
                <slot></slot>
            </main>
        </div>

    </div>
</template>

<script>

import JetBanner from '@/Jetstream/Banner'


export default {
    components: {
        JetBanner,
    },

    data() {
        return {

        }
    },

    created: function () {

    },
    beforeUnmount() {

    },

    methods: {

    }
}
</script>
